import { useCallback, useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSiteHeaderState } from '../../SiteHeader/redux/selectors';
import { EditorContext } from '../context';
import { useEditorDraftActions } from './useEditorDraftActions';
/**
 * Makes sure our draft states are updated before a window unloads
 *
 * Relies on our {@link EditorContext}.
 */
export function useEditorDraftUnmountEffects(editorId) {
    var state = useContext(EditorContext).state;
    var _a = useEditorDraftActions(editorId), saveEditorDraft = _a.saveEditorDraft, removeEditorDraft = _a.removeEditorDraft;
    var isLoggingOut = useSelector(function (reduxState) { return getSiteHeaderState(reduxState).isLoggingOut; });
    var handleBeforeUnload = useCallback(function () {
        var _a;
        var isEmpty = (_a = state === null || state === void 0 ? void 0 : state.isEmpty) !== null && _a !== void 0 ? _a : true;
        if (isLoggingOut) {
            // On logout we have a specific saga that clears all drafts
            return;
        }
        else if (!isEmpty && state) {
            saveEditorDraft(state);
        }
        else if (state) {
            removeEditorDraft();
        }
    }, [state, isLoggingOut, saveEditorDraft, removeEditorDraft]);
    // beforeunload instead of purely doing on unmount so
    // that page navigation also triggers a draft removal/save
    useEffect(function () {
        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', handleBeforeUnload);
        }
        return function () {
            if (typeof window !== 'undefined') {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            }
        };
    }, [handleBeforeUnload]);
}
//# sourceMappingURL=useEditorDraftUnmountEffects.js.map